/**
 * ML Trust features — autoplay slider on mobile
 */
(function () {
  const ROOT_SELECTOR = '[data-ml-tf]';
  const MOBILE_QUERY = '(max-width: 749px)';

  const getSlideStep = (track) => {
    const slide = track.querySelector('[data-ml-tf-slide]');
    if (!slide) return track.clientWidth;

    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return slide.getBoundingClientRect().width + gap;
  };

  const initTrustFeatures = (root) => {
    const track = root.querySelector('[data-ml-tf-track]');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('[data-ml-tf-slide]'));
    if (slides.length <= 1) return;

    const autoplayMs = parseInt(root.dataset.autoplay, 10) || 4000;
    const mobileQuery = window.matchMedia(MOBILE_QUERY);
    let timer = null;
    let scrollEndTimer = null;

    const stopAutoplay = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const scrollToIndex = (index) => {
      const step = getSlideStep(track);
      track.scrollTo({
        left: step * index,
        behavior: 'smooth',
      });
    };

    const getCurrentIndex = () => {
      const step = getSlideStep(track);
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!mobileQuery.matches || slides.length <= 1) return;

      timer = setInterval(() => {
        const current = getCurrentIndex();
        const next = current >= slides.length - 1 ? 0 : current + 1;
        scrollToIndex(next);
      }, autoplayMs);
    };

    const handleScrollEnd = () => {
      if (!mobileQuery.matches) return;

      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(() => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 2) {
          track.scrollTo({ left: 0, behavior: 'auto' });
        }
      }, 120);
    };

    mobileQuery.addEventListener('change', startAutoplay);
    track.addEventListener('scroll', handleScrollEnd, { passive: true });
    track.addEventListener('touchstart', stopAutoplay, { passive: true });
    track.addEventListener('touchend', () => {
      window.setTimeout(startAutoplay, autoplayMs);
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    startAutoplay();
  };

  const boot = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initTrustFeatures);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.(ROOT_SELECTOR);
    if (root) initTrustFeatures(root);
  });
})();
